import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

let ws;

export default new Vuex.Store({
  state: { messages: [], clickCount: 0, updateMode: true, currentPageName: ''},
  mutations: {
    setMessages(state, messages) {
      state.messages = messages;
    },
    setUpdateMode(state, mode) {
      state.updateMode = mode;
    },
    setCurrentPageName(state, pageName) {
      state.currentPageName = pageName;
    }
  },
  actions: {
    getMessages({ commit }) {
      if (ws) {
        return;
      }
      ws = new WebSocket('wss://echo.websocket.org');
      ws.addEventListener('message', (e) => {
        const data = JSON.parse(e.data);
        commit('setMessages', data.messages);
      });
    },
  },

});
